import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": /*@__PURE__*/_normalizeClass(['message-input-toolbar-list-end'])
};
import { ref, computed, onUnmounted } from "../../../adapter-vue";
import TUIChatEngine, { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import TUICore, { TUIConstants } from "@tencentcloud/tui-core";
import EmojiPicker from "./emoji-picker/index.vue";
import ImageUpload from "./image-upload/index.vue";
import FileUpload from "./file-upload/index.vue";
import VideoUpload from "./video-upload/index.vue";
import Evaluate from "./evaluate/index.vue";
import Words from "./words/index.vue";
import ToolbarItemContainer from "./toolbar-item-container/index.vue";
import UserSelector from "./user-selector/index.vue";
import { isPC, isH5, isUniFrameWork } from "../../../utils/env";
import TUIChatConfig from "../config";
import { enableSampleTaskStatus } from "../../../utils/enableSampleTaskStatus";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["insertEmoji"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var h5Dialog = ref();
    var currentConversation = ref();
    var isGroup = ref(false);
    var selectorShowType = ref("");
    var userSelectorRef = ref();
    var currentUserSelectorExtension = ref();
    var currentExtensionList = ref([]);
    var getExtensionList = function getExtensionList(conversationID) {
      if (!conversationID) {
        return currentExtensionList.value = extensionList;
      }
      var chatType = TUIChatConfig.getChatType();
      var options = {
        chatType: chatType
      };
      // 向下兼容，callkit 没有chatType 判断时，使用 filterVoice、filterVideo 过滤
      if (chatType === "customerService") {
        options.filterVoice = true;
        options.filterVideo = true;
        enableSampleTaskStatus("customerService");
      }
      currentExtensionList.value = _toConsumableArray(TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID, options));
    };
    var onCurrentConversationUpdate = function onCurrentConversationUpdate(conversation) {
      var _currentConversation$, _currentConversation$2;
      if (conversation !== null && conversation !== void 0 && conversation.conversationID && ((_currentConversation$ = currentConversation.value) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.conversationID) !== (conversation === null || conversation === void 0 ? void 0 : conversation.conversationID)) {
        getExtensionList(conversation === null || conversation === void 0 ? void 0 : conversation.conversationID);
      }
      currentConversation.value = conversation;
      if ((currentConversation === null || currentConversation === void 0 || (_currentConversation$2 = currentConversation.value) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.type) === TUIChatEngine.TYPES.CONV_GROUP) {
        isGroup.value = true;
      } else {
        isGroup.value = false;
      }
    };
    TUIStore.watch(StoreName.CONV, {
      currentConversation: onCurrentConversationUpdate
    });
    onUnmounted(function () {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdate
      });
    });
    // extensions
    var extensionList = _toConsumableArray(TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.INPUT_MORE.EXT_ID));
    // 按展示位置分类 extensionList （注意：仅 web 端 区分展示位置在 从 start 开始和 从 end 开始，在移动端不生效）
    var extensionListShowInStart = computed(function () {
      return isPC ? currentExtensionList.value.filter(function (extension) {
        var _extension$data;
        return (extension === null || extension === void 0 || (_extension$data = extension.data) === null || _extension$data === void 0 ? void 0 : _extension$data.name) !== "search";
      }) : currentExtensionList.value;
    });
    var extensionListShowInEnd = computed(function () {
      return isPC ? [currentExtensionList.value.find(function (extension) {
        var _extension$data2;
        return (extension === null || extension === void 0 || (_extension$data2 = extension.data) === null || _extension$data2 === void 0 ? void 0 : _extension$data2.name) === "search";
      })] : [];
    });
    // handle extensions onclick
    var onExtensionClick = function onExtensionClick(extension) {
      var _extension$data3, _extension$listener;
      switch (extension === null || extension === void 0 || (_extension$data3 = extension.data) === null || _extension$data3 === void 0 ? void 0 : _extension$data3.name) {
        case "voiceCall":
          onCallExtensionClicked(extension, 1);
          break;
        case "videoCall":
          onCallExtensionClicked(extension, 2);
          break;
        case "search":
          extension === null || extension === void 0 || (_extension$listener = extension.listener) === null || _extension$listener === void 0 || _extension$listener.onClicked();
          break;
        default:
          break;
      }
    };
    var onCallExtensionClicked = function onCallExtensionClicked(extension, callType) {
      var _extension$data4, _currentConversation$3;
      selectorShowType.value = extension === null || extension === void 0 || (_extension$data4 = extension.data) === null || _extension$data4 === void 0 ? void 0 : _extension$data4.name;
      if ((currentConversation === null || currentConversation === void 0 || (_currentConversation$3 = currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type) === TUIChatEngine.TYPES.CONV_C2C) {
        var _extension$listener2, _currentConversation$4;
        extension === null || extension === void 0 || (_extension$listener2 = extension.listener) === null || _extension$listener2 === void 0 || _extension$listener2.onClicked({
          userIDList: [currentConversation === null || currentConversation === void 0 || (_currentConversation$4 = currentConversation.value) === null || _currentConversation$4 === void 0 || (_currentConversation$4 = _currentConversation$4.conversationID) === null || _currentConversation$4 === void 0 ? void 0 : _currentConversation$4.slice(3)],
          type: callType
        });
      } else if (isGroup.value) {
        var _userSelectorRef$valu;
        currentUserSelectorExtension.value = extension;
        (userSelectorRef === null || userSelectorRef === void 0 || (_userSelectorRef$valu = userSelectorRef.value) === null || _userSelectorRef$valu === void 0 ? void 0 : _userSelectorRef$valu.toggleShow) && userSelectorRef.value.toggleShow(true);
      }
    };
    var genExtensionIcon = function genExtensionIcon(extension) {
      return extension === null || extension === void 0 ? void 0 : extension.icon;
    };
    var genExtensionText = function genExtensionText(extension) {
      return extension === null || extension === void 0 ? void 0 : extension.text;
    };
    var onUserSelectorSubmit = function onUserSelectorSubmit(selectedInfo) {
      var _currentUserSelectorE;
      (_currentUserSelectorE = currentUserSelectorExtension.value) === null || _currentUserSelectorE === void 0 || (_currentUserSelectorE = _currentUserSelectorE.listener) === null || _currentUserSelectorE === void 0 || _currentUserSelectorE.onClicked(selectedInfo);
      currentUserSelectorExtension.value = null;
    };
    var onUserSelectorCancel = function onUserSelectorCancel() {
      currentUserSelectorExtension.value = null;
    };
    var insertEmoji = function insertEmoji(emojiObj) {
      emits("insertEmoji", emojiObj);
    };
    var dialogShowInH5 = function dialogShowInH5(dialogDom) {
      var _h5Dialog$value, _h5Dialog$value2;
      if (!isH5) {
        return;
      }
      (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value = h5Dialog.value) === null || _h5Dialog$value === void 0 ? void 0 : _h5Dialog$value.appendChild) && (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value2 = h5Dialog.value) === null || _h5Dialog$value2 === void 0 ? void 0 : _h5Dialog$value2.appendChild(dialogDom));
    };
    var dialogCloseInH5 = function dialogCloseInH5(dialogDom) {
      var _h5Dialog$value3, _h5Dialog$value4;
      if (!isH5) {
        return;
      }
      (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value3 = h5Dialog.value) === null || _h5Dialog$value3 === void 0 ? void 0 : _h5Dialog$value3.removeChild) && (h5Dialog === null || h5Dialog === void 0 || (_h5Dialog$value4 = h5Dialog.value) === null || _h5Dialog$value4 === void 0 ? void 0 : _h5Dialog$value4.removeChild(dialogDom));
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['message-input-toolbar', !_unref(isPC) && 'message-input-toolbar-h5', _unref(isUniFrameWork) && 'message-input-toolbar-uni'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['message-input-toolbar-list', !_unref(isPC) && 'message-input-toolbar-h5-list', _unref(isUniFrameWork) && 'message-input-toolbar-uni-list'])
      }, [!_unref(isUniFrameWork) ? (_openBlock(), _createBlock(EmojiPicker, {
        key: 0,
        onInsertEmoji: insertEmoji,
        onDialogShowInH5: dialogShowInH5,
        onDialogCloseInH5: dialogCloseInH5
      })) : _createCommentVNode("", true), _unref(isUniFrameWork) ? (_openBlock(), _createBlock(ImageUpload, {
        key: 1,
        imageSourceType: "camera"
      })) : _createCommentVNode("", true), _createVNode(ImageUpload, {
        imageSourceType: "album"
      }), !_unref(isUniFrameWork) ? (_openBlock(), _createBlock(FileUpload, {
        key: 2
      })) : _createCommentVNode("", true), _createVNode(VideoUpload, {
        videoSourceType: "album"
      }), _unref(isUniFrameWork) ? (_openBlock(), _createBlock(VideoUpload, {
        key: 3,
        videoSourceType: "camera"
      })) : _createCommentVNode("", true), _createVNode(Evaluate), _createVNode(Words), _unref(extensionListShowInStart)[0] ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 4
      }, _renderList(_unref(extensionListShowInStart), function (extension) {
        return _openBlock(), _createBlock(ToolbarItemContainer, {
          iconFile: genExtensionIcon(extension),
          title: genExtensionText(extension),
          iconWidth: _unref(isUniFrameWork) ? '25px' : '20px',
          iconHeight: _unref(isUniFrameWork) ? '25px' : '20px',
          needDialog: false,
          onOnIconClick: function onOnIconClick($event) {
            return onExtensionClick(extension);
          }
        }, null, 8, ["iconFile", "title", "iconWidth", "iconHeight", "onOnIconClick"]);
      }), 256)) : _createCommentVNode("", true)], 2), _unref(extensionListShowInEnd)[0] && _unref(isPC) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extensionListShowInEnd), function (extension) {
        return _openBlock(), _createBlock(ToolbarItemContainer, {
          iconFile: genExtensionIcon(extension),
          title: genExtensionText(extension),
          iconWidth: _unref(isUniFrameWork) ? '25px' : '20px',
          iconHeight: _unref(isUniFrameWork) ? '25px' : '20px',
          needDialog: false,
          onOnIconClick: function onOnIconClick($event) {
            return onExtensionClick(extension);
          }
        }, null, 8, ["iconFile", "title", "iconWidth", "iconHeight", "onOnIconClick"]);
      }), 256))])) : _createCommentVNode("", true), _createVNode(UserSelector, {
        ref_key: "userSelectorRef",
        ref: userSelectorRef,
        type: _unref(selectorShowType),
        currentConversation: _unref(currentConversation),
        isGroup: _unref(isGroup),
        onSubmit: onUserSelectorSubmit,
        onCancel: onUserSelectorCancel
      }, null, 8, ["type", "currentConversation", "isGroup"]), _unref(isH5) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['message-input-toolbar-h5-dialog']),
        ref_key: "h5Dialog",
        ref: h5Dialog
      }, null, 512)) : _createCommentVNode("", true)], 2);
    };
  }
});